<template>
  <aside class="menu menu--sidebar is-collapsed">
    <ul class="menu-list">
      <li>
        <permissions-control-wrapper
          :action="title"
          :clarification="true"
          :required-general="$PERMISSIONS_GENERAL.ADD"
          :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.CUSTOM_FOOD_ITEMS"
          :permissions="_get(StuffToEatList, 'meta.permissions')">
          <template slot="allowed">
            <router-link
               tag="a" activeClass="is-active"
              :title="$t(title)"
              :to="{ name: link }">
              <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
            </router-link>
          </template>
          <template slot="not-allowed">
            <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button" :disabled="true"></nuttrema-iconica-sidebar-link>
          </template>
        </permissions-control-wrapper>
      </li>
    </ul>
  </aside>
</template>

<script>
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'cmpt-button-add-new-stuff-to-eat',
  props: {
    type: {
      type: String,
      required: true,
      default: null,
    },
    link: {
      type: String,
      required: true,
      default: null,
    },
    title: {
      type: String,
      required: true,
      default: 'title',
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  computed: {
    StuffToEatList() {
      return this.$store.getters.StuffToEatList(this.type);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/blocks/cmpt-button-add-new.vue